var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineUserSpeaker32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1673 28V25.3333C27.1673 22.3878 24.7795 20 21.834 20H11.1673C8.2218 20 5.83398 22.3878 5.83398 25.3333V28M21.834 9.33333C21.834 12.2789 19.4462 14.6667 16.5007 14.6667C13.5551 14.6667 11.1673 12.2789 11.1673 9.33333C11.1673 6.38781 13.5551 4 16.5007 4C19.4462 4 21.834 6.38781 21.834 9.33333Z",
    stroke: "#1778E1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.834 5.33323C26.5007 5.9999 27.1673 7.33323 27.1673 9.33323C27.1673 11.3332 26.5007 12.6666 25.834 13.3332M29.834 1.33325C31.834 3.33325 32.5006 6.66658 32.5006 9.33323C32.5006 11.9999 31.834 15.3333 29.834 17.3333",
    stroke: "#1778E1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineUserSpeaker32);
export default __webpack_public_path__ + "static/media/outline-user-speaker-32.ca642b86.svg";
export { ForwardRef as ReactComponent };